import Vue from 'vue'
import App from './App.vue'
// import Axios from 'axios'
import Meta from 'vue-meta'
import { store } from '@/app/store'
import router from '@/app/routes'
import '@/assets/sass/style.scss'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import i18n from './i18n'
import VScrollLock from 'v-scroll-lock'
import VueObserveVisibility from 'vue-observe-visibility'
import VueScrollTo from 'vue-scrollto';
import VueLazyload from 'vue-lazyload'
import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB857NUWT8lQKGENCtptYZQDb4mAEvQ8Ko',
    libraries: "places,drawing,visualization"
    // libraries: 'places'
  },
})


Vue.use(VueLazyload)
Vue.use(VueScrollTo)
Vue.use(VueObserveVisibility)
Vue.use(VScrollLock)
Vue.use(VueAwesomeSwiper)
Vue.use(Meta)
// Vue.use(Axios)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  components: { App }
}).$mount('#app')
